<template lang="pug">
.fields-screen
  .row
    //- configure envelope
    envelope-step-bar(:runBeforeNavigate='saveFields' :step='3')
    .col-lg-4.col-xl-3
      .row
        .col-sx-12
          h3.title-font-size.mb-2 {{ $t('modal.envelope.fields.configureSigners') }}
          .card.card--rounded.shadow-none.recipient-card.mb-4
            .card-body.pb-2
              p.font-size-subtitle.ms-2.mb-1 {{ $t('modal.envelope.fields.selectSigner') }}
              .recipient-select
                aol-select(
                  :options='signers'
                  label='name'
                  v-model='signerSelected'
                )
                  template(v-slot:no-options='{}') {{ $t('modal.envelope.fields.noSignersFound') }}
                  template(v-slot:option='{ name, email }')
                    div {{ name }}
                    small {{ email }}
                  template(v-slot:prepend='{}') @
              .recipient-block(v-if='signerSelected')
                .form-check.mt-2(v-if='selectedDocument')
                  input#exclude-document.form-check-input(
                    :checked='isExcludedRecipientFromDocument'
                    :disabled='disableExcludeCheckbox'
                    @change='toggleExcludeDocument'
                    type='checkbox'
                  )
                  label.form-check-label.text(for='exclude-document') {{ $t('modal.envelope.fields.doesNotSignThisDocument') }}
                  icon.ms-2(
                    name='circle-question'
                    v-tooltip:right='$t("modal.envelope.fields.doesNotSignThisDocumentInfo")'
                  )
                p.font-size-subtitle.ms-2.mt-4.mb-2 {{ $t('modal.envelope.fields.signerFields') }}
                draggable.drag-area.d-flex.flex-column(
                  :forceFallback='true'
                  :group='{ name: "elements", pull: "clone", put: false }'
                  :list='allUserElements'
                  @end='onDragEnd'
                  @start='onDragStart'
                  draggable='.item'
                )
                  .item.drag-item.badge(
                    :class='{ blocked: shouldBlockField(item, signerSelected) }'
                    :data-element='JSON.stringify(item)'
                    :data-recipient='JSON.stringify(signerSelected)'
                    :key='`content-${index}`'
                    v-for='(item, index) in allUserElements'
                    v-if='checkRecipientElements(item, signerSelected)'
                    v-tooltip:top='item.description'
                  )
                    .item-content.d-flex.align-items-center
                      .icon-background
                        icon(:name='item.icon')
                      .text.field-name.ms-2 {{ item.name }}
                    icon.me-2.fs-5(name='grip-dots-vertical')
        .col-sx-12
          h3.title-font-size.mb-2 {{ $t('modal.envelope.fields.customizeDocument') }}
          .card.card--rounded.shadow-none.recipient-card.mb-5
            .card-body.pb-2
              draggable.drag-area.d-flex.flex-column(
                :forceFallback='true'
                :group='{ name: "elements", pull: "clone", put: false }'
                :list='documentElements'
                @end='onDragEnd'
                @start='onDragStart'
                draggable='.item'
              )
                .item.drag-item.badge(
                  :class='{ blocked: shouldBlockField(item, signerSelected) }'
                  :data-element='JSON.stringify(item)'
                  :key='`content-${index}`'
                  v-for='(item, index) in documentElements'
                  v-if='signerSelected'
                  v-tooltip:top='item.description'
                )
                  .item-content.d-flex.align-items-center
                    .icon-background
                      icon(:name='item.icon')
                    span.text.field-name.ms-2 {{ item.name }}
                  icon.me-2.fs-5(name='grip-dots-vertical')
      //- End - Recipients
    .col-lg-8.col-xl-9
      documents-render(
        :document='documents[0]'
        :documents='documents'
        :elements='elements'
        :overlappingIds='overlappingIds'
        :overlappingWarning='overlappingMessage'
        @changeDocument='selectedDocument = $event'
        @deleteElement='onDeleteElement'
        @dropElement='onDropElement'
        @updateElement='onUpdateElement'
        v-if='documents.length > 0'
      )
  envelope-bottom-bar(
    :disableButtonNextStep='errorOnSave'
    :discardAndClose='isTemplate'
    :showSubmitToReviewButton='submitToReviewAvailable'
    @discardAndClose='discardChanges'
    @nextStep='next'
    @openSubimitToReview='openSubmitToReview'
    @saveAndClose='saveAndClose'
    v-if='true'
  )
  confirm-exclude-document-signer-modal(
    @process='confirmExcludeDocument'
    ref='confirmExcludeDocumentSignerModal'
  )
  warning-discard-and-close-envelope-modal(
    @discardChanges='discardChanges'
    ref='discardAndCloseModal'
  )
  warning-save-and-close-envelope-modal(
    @discardChanges='discardChanges'
    @saveAndClose='saveAndClose'
    ref='warningSaveAndCloseEnvelopeModal'
  )
    p.mb-0 {{ $t('modal.envelope.fields.discardChangesMessage') }}
  onboarding-fields-modal(
    @finished='handleOnboardingFinished'
    ref='onboardingFieldsModal'
  )
  submit-envelope-to-review-modal(
    :envelope='envelope'
    :visibilityOptions='visibilityOptionsForModal'
    :visibilitySelected='currentVisibilityValue'
    @envelope-submitted-to-review='openEnvelopeSubmittedToReviewModal'
    ref='submitEnvelopeToReviewModal'
  )
  envelope-submitted-to-review-modal(ref='envelopeSubmittedToReviewModal')
  warning-change-envelope-reviewer-modal(
    @changeEnvelopeReviewer='changeEnvelopeReviewer'
    ref='changeEnvelopeReviewerModal'
  )
</template>
<script>
import Draggable from 'vuedraggable';
import Icon from '@/ui/atoms/Icon.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import DocumentsRender from '@/ui/organisms/DocumentsPDFRender.vue';
import EnvelopeManager from '@/modules/business/services/EnvelopeManager';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import EnvelopeStepBar from '@/ui/organisms/EnvelopeStepBar.vue';
// eslint-disable-next-line max-len
import WarningSaveAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseEnvelope.vue';
import OnboardingFieldsModal from '@/ui/organisms/modals/OnboardingFieldsModal.vue';
import RecipientType from '@/enums/RecipientType';
import EnvelopeState from '@/enums/EnvelopeState';
import { mapGetters, mapActions } from 'vuex';
import alert from '@/modules/account/common/alert';
import config from '@/config';
// eslint-disable-next-line max-len
import ConfirmExcludeDocumentSignerModal from '@/modules/business/components/organisms/modals/ConfirmExcludeDocumentSignerModal.vue';
import WarningDiscardAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningDiscardAndCloseEnvelopeModal.vue';
import {
  getAllowedVisibilities,
  getCurrentVisibilityValue,
  getVisibilityOptions,
} from '@/modules/business/common/envelopeVisibility';
import SubmitEnvelopeToReviewModal from '@/modules/business/components/organisms/modals/SubmitEnvelopeToReviewModal.vue';
import EnvelopeSubmittedToReviewModal from '@/modules/business/components/organisms/modals/EnvelopeSubmittedToReviewModal.vue';
import Logger from '@/services/Logger';
import TeamsService from '@/modules/account/services/http/TeamsService';
import WarningChangeEnvelopeReviewerModal from '@/modules/business/components/organisms/modals/WarningChangeEnvelopeReviewerModal.vue';

export default {
  /* eslint-disable max-len */
  name: 'EnvelopeFields',
  components: {
    WarningChangeEnvelopeReviewerModal,
    EnvelopeSubmittedToReviewModal,
    SubmitEnvelopeToReviewModal,
    ConfirmExcludeDocumentSignerModal,
    DocumentsRender,
    Draggable,
    Icon,
    EnvelopeBottomBar,
    EnvelopeStepBar,
    WarningSaveAndCloseEnvelopeModal,
    WarningDiscardAndCloseEnvelopeModal,
    OnboardingFieldsModal,
    alert,
  },
  data() {
    return {
      documents: [],
      selectedDocument: null,
      recipients: [],
      signerSelected: null,
      nextRoute: null,
      documentsFields: [],
      documentsContents: [],
      recipientElements: [
        {
          icon: 'signature',
          type: 'signature',
          name: this.$t('modal.envelope.fields.signature'),
          description: this.$t('modal.envelope.fields.signatureDescription'),
          category: 'field',
          required: true,
          resizable: true,
          autoSize: true,
        },
        {
          icon: 'file-contract',
          type: 'initial',
          name: this.$t('modal.envelope.fields.initial'),
          description: this.$t('modal.envelope.fields.initialDescription'),
          category: 'field',
          settings: true,
          key: 0,
          required: true,
          resizable: true,
          autoSize: true,
        },
      ],
      formElements: [
        {
          icon: 'square-list',
          type: 'dropdown',
          name: this.$t('modal.envelope.fields.options'),
          description: this.$t('modal.envelope.fields.optionsDescription'),
          category: 'field',
          fieldName: '',
          settings: true,
          key: 0,
          options: [],
          openOnDrop: true,
          resizable: false,
        },
        {
          icon: 'text',
          type: 'text',
          name: this.$t('modal.envelope.fields.text'),
          description: this.$t('modal.envelope.fields.textDescription'),
          category: 'field',
          fieldName: '',
          settings: true,
          key: 0,
          resizable: true,
          openOnDrop: true,
          updateFontSize: false,
          sticks: ['mr', 'ml'],
          aspectRatio: false,
        },
        // {
        //   icon: 'circle',
        //   type: 'radio-group',
        //   name: 'Radio',
        //   category: 'field',
        //   fieldName: '',
        //   settings: true,
        //   openOnDrop: true,
        //   sizeFitContent: true,
        // },
        {
          icon: 'square-check',
          type: 'checkbox',
          name: this.$t('modal.envelope.fields.checkbox'),
          description: this.$t('modal.envelope.fields.checkboxDescription'),
          category: 'field',
          fieldName: '',
          settings: true,
          key: 0,
          openOnDrop: true,
          resizable: false,
        },
      ],
      documentElements: [
        {
          icon: 'comment-dots',
          type: 'comment',
          name: this.$t('modal.envelope.fields.comments'),
          description: this.$t('modal.envelope.fields.commentsDescription'),
          category: 'content',
          value: '',
          settings: true,
          key: 0,
          openOnDrop: true,
          resizable: false,
        },
        {
          icon: 'folder-image',
          type: 'image',
          name: this.$t('modal.envelope.fields.image'),
          description: this.$t('modal.envelope.fields.imageDescription'),
          category: 'content',
          value: '',
          settings: false,
          key: 0,
          openOnDrop: true,
          resizable: true,
          image: '',
        },
        {
          icon: 'calendar',
          type: 'date',
          name: this.$t('modal.envelope.fields.date'),
          description: this.$t('modal.envelope.fields.dateDescription'),
          category: 'content',
          value: '',
          settings: true,
          key: 0,
          resizable: false,
          openOnDrop: true,
        },
        // {
        //   icon: 'qrcode',
        //   type: 'validation-qrcode',
        //   name: 'QR Code',
        //   description: 'Autenticar documento com QR Code',
        //   category: 'content',
        //   resizable: true,
        //   openOnDrop: true,
        // },
      ],
      elements: [],
      excludeRecipientsPayload: [],
      fromApiExcludeRecipientsPayload: [],
      isExcludedRecipientFromDocument: false,
      errorOnSave: false,
      pendingSave: false,
      errorDocuments: new Set(),
      envelope: {},
      teams: [],
      teamsLoaded: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'business.envelope.recipients' ||
      to.name === 'business.envelope.review' ||
      to.name === 'business.documents.waiting-review' ||
      to.name === 'business.documents.draft'
    ) {
      next();
      return;
    }
    if (this.isTemplate) {
      this.$refs.discardAndCloseModal.$refs.modal.open();
      this.nextRoute = next;
      return;
    }
    this.$refs.warningSaveAndCloseEnvelopeModal.$refs.modal.open();
    this.nextRoute = next;
  },
  created() {
    const self = this;
    let pageTitle = self.getPageTitle;
    if (this.$route.params.isNew) {
      pageTitle = self.$t('newEnvelope');
    }
    this.$store.dispatch('page/setTitle', pageTitle);
    this.$store.dispatch('page/setHead', {
      title: pageTitle,
      action() {
        self.$router.replace({
          name: 'business.envelope.recipients',
          params: {
            id: self.$route.params.id,
            isNew: self.$route.params.isNew,
          },
        });
      },
      help() {
        self.$refs.onboardingFieldsModal.$refs.modal.open();
      },
    });
    this.$loading(false);
  },
  async beforeMount() {
    const res = await EnvelopesService.getExtendedEnvelope(
      this.$route.params.id
    );
    this.envelope = res.data;
    this.recipients = res.data.recipients.map((recipient, index) => {
      if (!this.isTemplate) {
        return {
          ...recipient,
          name: recipient.addressees?.[0]?.name ?? '',
          email: recipient.addressees?.[0]?.value ?? '',
        };
      }
      const addressee = recipient.addressees?.[0];
      const addresseeName = addressee?.name
        ? addressee.name
        : this.$t('recipient') + (index + 1); // use addressee name or mock
      const name = recipient.role ? recipient.role : addresseeName;
      const email = addressee?.value ? addressee.value : ''; // do not show value for templates (email, phone)
      // mock addressees for templates, because it is used for to render fields
      return {
        ...recipient,
        name,
        email,
        addressees: [
          {
            ...addressee,
            name: name,
            via: addressee?.via ?? 'email',
            value: email,
            identifiers: addressee?.identifiers ?? [],
          },
          ...(recipient.addressees ?? []).slice(1),
        ],
      };
    });
    // pre-populate the pending payload with the exclusions already persisted from the API
    this.excludeRecipientsPayload = this.recipients.flatMap((recipient) =>
      (recipient.exclude_documents || []).map((documentUuid) => ({
        documentUuid,
        recipientUuid: recipient.id,
      }))
    );
    this.fromApiExcludeRecipientsPayload = [...this.excludeRecipientsPayload];
    this.metadata = res.data.metadata || {};
    [this.signerSelected] = this.signers;
    this.documents = res.data.documents.map((doc) => {
      const document = doc;
      document.src = document.links.display;
      const elements = !this.isTemplate
        ? EnvelopeManager.extratElementsFromDocument(
            document,
            res.data.recipients
          )
        : EnvelopeManager.extratElementsFromDocument(document, this.recipients);
      this.elements = this.elements.concat(elements);
      return document;
    });
    this.selectedDocument = this.documents[0];
    await this.fetchTeams();
  },
  async mounted() {
    await this.$store.dispatch('onboardings/getOnboardings');
    if (!this.getOnboarding('business_envelope_fields')) {
      this.$refs.onboardingFieldsModal.$refs.modal.open();
    }
  },
  watch: {
    hasSomeMaxOverlap: {
      handler(newVal) {
        if (!this.selectedDocument?.elements || !this.elements?.length) {
          this.errorOnSave = false;
          return;
        }
        if (newVal === false && !this.pendingSave) {
          this.errorOnSave = false;
        }
      },
      immediate: true,
    },
    signerSelected() {
      /**
       * When switching signers, recalculate the computed value for
       * the new pair and update the checkbox display.
       * */
      this.isExcludedRecipientFromDocument =
        this.isRecipientInExcludedDocumentsPayload;
    },
    selectedDocument() {
      /**
       * When switching documents, recalculate the computed value for
       * the new pair and update the checkbox display.
       * */
      this.isExcludedRecipientFromDocument =
        this.isRecipientInExcludedDocumentsPayload;
    },
  },
  computed: {
    ...mapGetters({ getOnboarding: 'onboardings/getOnboarding' }),
    allUserElements() {
      return this.recipientElements.concat(this.formElements);
    },
    signers() {
      return this.recipients.filter(
        (recipient) => recipient.type === RecipientType.SIGNER
      );
    },
    hasSignatureFieldForSelectedSignerInDocument() {
      return (
        this.elements.find(
          (item) =>
            item.category === 'field' &&
            item.type === 'signature' &&
            item.document == this.selectedDocument.id &&
            this.signerSelected.id === item.recipient.id
        ) !== undefined
      );
    },
    disableExcludeCheckbox() {
      if (!this.signerSelected || !this.selectedDocument) {
        // fallback
        return true;
      }
      // when is pdf-a enabled, and has signed documents metadata
      if (this.isPdfAWithSignedDocumentsExcluded) {
        return true;
      }
      if (this.isExcludedRecipientFromDocument) {
        // the user can always undo an exclusion
        return false;
      }
      if (this.documents.length === 1) {
        return true;
      }
      // counts how many documents exist besides the current one
      const excludedDocsForRecipientCount =
        this.excludeRecipientsPayload.filter(
          (item) => item.recipientUuid === this.signerSelected.id
        ).length;
      return excludedDocsForRecipientCount >= this.documents.length - 1;
    },
    hasOverlappingElements() {
      const overlaps = [];
      // get selected documents
      const doc = this.selectedDocument;

      if (!doc) {
        return overlaps;
      }

      // filter by actual document
      const elements =
        this.elements?.filter((el) => el.document === doc.id) || [];
      if (doc.elements) {
        elements.push(...doc.elements);
      }
      if (!elements.length) {
        return overlaps;
      }
      // get fields and contents
      const fieldsAndContents = this.mapFieldsAndContentsForOverlap(elements);
      // compare pairs of fields and contents in same doc and same page
      for (let i = 0; i < fieldsAndContents.length; i++) {
        const el1 = fieldsAndContents[i];
        for (let j = i + 1; j < fieldsAndContents.length; j++) {
          const el2 = fieldsAndContents[j];
          // if different pages, skip
          if (el1.page !== el2.page) {
            continue;
          }
          // other elements can overlap images
          if (el1.type === 'image' || el2.type === 'image') {
            continue;
          }

          const overlap = this.calculateOverlap(el1, el2);
          // overlap > 50%
          if (overlap > this.$root.warningOverlapPercent) {
            const percent = (overlap * 100).toFixed(1);
            const field1 = el1.type;
            const field2 = el2.type;
            const message = this.$t(
              'modal.envelope.fields.overlapElementWarning',
              {
                percent: percent,
                field1: this.$t(`modal.envelope.fields.${field1}`),
                field2: this.$t(`modal.envelope.fields.${field2}`),
              }
            );
            overlaps.push({
              overlapping: true,
              element1: el1,
              element2: el2,
              overlapPercentage: overlap,
              overlappingIds: [el1.id, el2.id].filter(Boolean),
              warningMessage: message,
            });
          }
        }
      }
      return overlaps;
    },
    hasSomeMaxOverlap() {
      const maxOverlap = config.overlapFieldsMaxPercent;
      return this.hasOverlappingElements.some(
        (overlap) => overlap.overlapPercentage > maxOverlap
      );
    },
    overlappingIds() {
      const ids = [];
      if (this.hasOverlappingElements?.length) {
        for (const overlap of this.hasOverlappingElements) {
          for (const id of overlap.overlappingIds) {
            ids.push(id);
          }
        }
      }
      return ids;
    },
    overlappingMessage() {
      const messages = [];
      if (this.hasOverlappingElements?.length) {
        for (const overlap of this.hasOverlappingElements) {
          for (const id of overlap.overlappingIds) {
            messages.push({
              id: id,
              message: overlap.warningMessage,
            });
          }
        }
      }
      return messages;
    },
    isRecipientInExcludedDocumentsPayload() {
      return this.excludeRecipientsPayload.some(
        (item) =>
          item.documentUuid === this.selectedDocument.id &&
          item.recipientUuid === this.signerSelected.id
      );
    },
    isSelectedDocumentSigned() {
      const documentUuid = this.selectedDocument?.id;
      const signedDocuments = this.metadata?.['has.signed_documents'];
      return (
        Boolean(documentUuid) &&
        Array.isArray(signedDocuments) &&
        signedDocuments.includes(documentUuid)
      );
    },
    isPdfAWithSignedDocumentsExcluded() {
      const isPdfa = this.metadata?.['type.pdfa'] === true;
      const hasSignedDocuments = this.metadata?.['has.signed_documents'] ?? [];
      return (
        isPdfa &&
        hasSignedDocuments.length > 0 &&
        this.isSelectedDocumentSigned &&
        this.isRecipientInExcludedDocumentsPayload
      );
    },
    selectedRecipientHasFieldsInSelectedDocument() {
      if (!this.signerSelected || !this.selectedDocument) {
        return false;
      }
      return this.elements.some(
        (el) =>
          el.category === 'field' &&
          el.document === this.selectedDocument.id &&
          el.recipient?.id === this.signerSelected.id
      );
    },
    isTemplate() {
      return (
        this.$route.params.isTemplate == true ||
        this.envelope.state === 'template'
      );
    },
    submitToReviewAvailable() {
      const allowedVisibilities = getAllowedVisibilities(
        this.$store.state.organizations.selected
      );
      return (
        this.envelope.state === EnvelopeState.DRAFT &&
        allowedVisibilities.length > 0
      );
    },
    isWaitingReview() {
      return this.envelope.state === EnvelopeState.WAITING_REVIEW;
    },
    isNewTemplate() {
      return this.isTemplate && this.$route.params.isNewTemplate == true;
    },
    availableVisibilities() {
      return getAllowedVisibilities(this.$store.state.organizations.selected);
    },
    visibilityOptionsForModal() {
      return getVisibilityOptions({
        visibilities: this.availableVisibilities,
        teams: this.teams,
        translate: (key) => this.$t(key),
      });
    },
    currentVisibilityValue() {
      return getCurrentVisibilityValue(this.envelope);
    },
    getPageTitle() {
      if (this.isNewTemplate) {
        return this.$t('newTemplate');
      } else if (this.isTemplate) {
        return this.$t('editTemplate');
      }
      return this.$t('editEnvelope');
    },
  },
  methods: {
    async openSubmitToReview() {
      if (this.pendingSave) {
        return;
      }
      this.errorOnSave = false;
      try {
        await this.handleExcludeRecipientsFromDocuments();
        await this.saveFields();
        if (this.errorOnSave) {
          return;
        }
      } catch (e) {
        Logger.consoleError(
          'Error to save fields, its not submitted to review:',
          e
        );
        return;
      }
      this.$refs.submitEnvelopeToReviewModal.open();
    },
    async fetchTeams() {
      if (this.teamsLoaded || !this.availableVisibilities.includes('team')) {
        return;
      }
      try {
        const response = await TeamsService.list();
        this.teams = response.data.data;
        this.teamsLoaded = true;
      } catch {
        this.teams = [];
      }
    },
    async toggleExcludeDocument(event) {
      const wasExcluded = this.isExcludedRecipientFromDocument;
      const nextExcluded = !wasExcluded;

      if (nextExcluded && this.selectedRecipientHasFieldsInSelectedDocument) {
        // keeps the checkbox unchecked as it was until the user confirms
        event.target.checked = wasExcluded;
        this.$refs.confirmExcludeDocumentSignerModal.$refs.modal.open();
        return;
      }
      // no have fields to remove
      this.isExcludedRecipientFromDocument = nextExcluded;
      this.syncExcludedDocumentsFromRecipient();
    },
    async confirmExcludeDocument() {
      /**
       * Remove existing fields from a recipient document
       * when this recipient has fields in a selected document
       * when this document is excluded from the recipient
       */
      this.isExcludedRecipientFromDocument = true;
      this.syncExcludedDocumentsFromRecipient();

      this.$loading(true);
      try {
        // when there exist fields to remove
        await this.removeFieldsForSelectedRecipientDocument();
      } catch (error) {
        // rollback - when error to remove from api fields
        this.isExcludedRecipientFromDocument = false;
        this.syncExcludedDocumentsFromRecipient();
        const message = this.$t('modal.envelope.fields.elementError');
        alert.fireAlert(message, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
      } finally {
        this.$loading(false);
        this.$refs.confirmExcludeDocumentSignerModal.$refs.modal.close();
      }
    },
    async removeFieldsForSelectedRecipientDocument() {
      const envelopeId = this.$route.params.id;
      const documentId = this.selectedDocument.id;
      const recipientId = this.signerSelected.id;

      const fieldsToRemove = this.elements.filter(
        (el) =>
          el.category === 'field' &&
          el.document === documentId &&
          el.recipient?.id === recipientId
      );
      const fieldsToRemoveFromApi = fieldsToRemove.filter(
        (field) => field.inApi
      );

      await Promise.all(
        fieldsToRemoveFromApi.map((field) =>
          EnvelopesService.removeDocumentField(envelopeId, documentId, field.id)
        )
      );

      this.elements = this.elements.filter(
        (el) => !fieldsToRemove.includes(el)
      );
    },
    syncExcludedDocumentsFromRecipient() {
      if (this.isExcludedRecipientFromDocument) {
        this.excludeRecipientsPayload.push({
          documentUuid: this.selectedDocument.id,
          recipientUuid: this.signerSelected.id,
        });
      } else if (
        !this.isExcludedRecipientFromDocument &&
        this.isRecipientInExcludedDocumentsPayload
      ) {
        this.excludeRecipientsPayload = this.excludeRecipientsPayload.filter(
          (item) =>
            !(
              item.documentUuid === this.selectedDocument.id &&
              item.recipientUuid === this.signerSelected.id
            )
        );
      }
    },
    shouldBlockField(item, recipient) {
      if (!recipient) return false;

      if (item.category === 'field' && this.isExcludedRecipientFromDocument) {
        return true;
      }

      const isPdfa = this.metadata?.['type.pdfa'] === true;
      if (!isPdfa) return false;

      if (
        item.type === 'signature' &&
        this.hasSignatureFieldForSelectedSignerInDocument
      ) {
        return true;
      }

      return item.type === 'initial';
    },
    verifyOverlapInAllDocs(overlapQuote) {
      // check if any document has any overlapping fields or content
      for (const doc of this.documents) {
        const elements = this.elements?.filter((el) => el.document === doc.id);
        if (doc.elements) {
          elements.push(...doc.elements);
        }
        if (!elements.length) {
          return false;
        }
        // get fields and contents
        const fieldsAndContents = this.mapFieldsAndContentsForOverlap(elements);
        // compare pairs of fields and contents in same doc and same page
        for (let i = 0; i < fieldsAndContents.length; i++) {
          const el1 = fieldsAndContents[i];
          for (let j = i + 1; j < fieldsAndContents.length; j++) {
            const el2 = fieldsAndContents[j];
            // if different pages, skip
            if (el1.page !== el2.page) {
              continue;
            }
            // other elements can overlap images
            if (el1.type === 'image' || el2.type === 'image') {
              continue;
            }
            const overlap = this.calculateOverlap(el1, el2);
            if (overlap > overlapQuote) {
              return true;
            }
          }
        }
      }
      return false;
    },
    mapFieldsAndContentsForOverlap(elements) {
      return elements
        ?.filter((e) => ['field', 'content'].includes(e.category))
        .map((el) => ({
          ...el,
          apiX: el.x ?? el.apiX ?? 0,
          apiY: el.y ?? el.apiY ?? 0,
          apiWidth: el.width ?? el.apiWidth ?? 0,
          apiHeight: el.height ?? el.apiHeight ?? 0,
          page: el.page ?? 1,
        }))
        .filter(
          (el) =>
            el.apiX != null &&
            el.apiY != null &&
            el.apiWidth > 10 &&
            el.apiHeight > 10
        );
    },
    onDragStart() {
      document.body.style.userSelect = 'none';
    },
    onDragEnd() {
      document.body.style.userSelect = 'auto';
    },
    ...mapActions({ updateOnboarding: 'onboardings/updateOnboarding' }),
    handleOnboardingFinished() {
      this.updateOnboarding({
        onboardingName: 'business_envelope_fields',
        value: true,
      });
    },
    checkRecipientElements(element, recipient) {
      if (
        recipient.type !== 'signer' &&
        element.category === 'field' &&
        ['text', 'signature', 'initial', 'checkbox', 'dropdown'].includes(
          element.type
        )
      ) {
        return false;
      }
      return true;
    },
    onDropElement(element) {
      // new element in frontend
      this.elements.push({
        ...element,
        inApi: false,
        updated: false,
      });
      this.errorOnSave = false;
    },
    onUpdateElement(element) {
      const index = this.elements.findIndex((i) => i.id === element.id);
      if (index === -1) {
        return;
      }
      const originalElement = this.elements[index];
      // save snapshot for comparing - skip first render
      if (!originalElement._initialized) {
        originalElement._initialized = true;
        originalElement._original = {
          updated: false,
          x: originalElement.x,
          y: originalElement.y,
          width: originalElement.width,
          height: originalElement.height,
        };
        return;
      }
      const positionTolerance = 25; // 10 px tolerance for y and x
      const sizeTolerance = 50; // 50 px tolerance for width and height
      let hasRealChange = false;
      if (originalElement.inApi) {
        const compare = [
          {
            current: element.x,
            snapshot: originalElement._original?.x,
            tolerance: positionTolerance,
            ratio: element.x / originalElement.apiX,
          },
          {
            current: element.y,
            snapshot: originalElement._original?.y,
            tolerance: positionTolerance,
            ratio: element.y / originalElement.apiY,
          },
          {
            current: element.width,
            snapshot: originalElement._original?.width,
            tolerance: sizeTolerance,
            ratio: element.width / originalElement.apiWidth,
          },
          {
            current: element.height,
            snapshot: originalElement._original?.height,
            tolerance: sizeTolerance,
            ratio: element.height / originalElement.apiHeight,
          },
        ];
        const normalize = (v) => Math.round(v);
        hasRealChange = compare.some(
          ({ current, snapshot, tolerance }) =>
            current !== undefined &&
            snapshot !== undefined &&
            snapshot !== 'auto' &&
            Math.abs(normalize(current) - normalize(snapshot)) > tolerance
        );
      }
      const sanitizedElement = Object.fromEntries(
        Object.entries(element).filter(([, v]) => v !== undefined)
      );
      sanitizedElement.updated = originalElement.inApi ? hasRealChange : false;
      this.$set(this.elements, index, {
        ...originalElement,
        ...sanitizedElement,
      });
      this.errorOnSave = false;
    },
    onDeleteElement(element, document) {
      if (element.inApi) {
        if (element.category === 'field') {
          EnvelopesService.removeDocumentField(
            this.$route.params.id,
            document.id,
            element.id
          ).then(() => {
            this.elements = this.elements.filter((i) => i.id !== element.id);
          });
        }
        if (element.category === 'content') {
          EnvelopesService.removeDocumentContent(
            this.$route.params.id,
            document.id,
            element.id
          ).then(() => {
            this.elements = this.elements.filter((i) => i.id !== element.id);
          });
        }
      } else {
        this.elements = this.elements.filter((i) => i.id !== element.id);
      }
    },
    groupBy(array, key) {
      return array.reduce((result, item) => {
        (result[item[key]] = result[item[key]] || []).push(item);
        return result;
      }, {});
    },
    async saveFields() {
      if (!this.elements.length) {
        return;
      }
      if (this.pendingSave) {
        return;
      }
      this.pendingSave = true;
      this.$loading(true);
      this.errorDocuments.clear();
      try {
        let promises = [];
        const contentsToInsert = [];
        const fieldsToInsert = [];

        for (const element of this.elements) {
          if (element.inApi && !element.updated) {
            // existing element without changes, no update
            continue;
          }

          if (!element.inApi) {
            // new element
            if (element.category === 'content') {
              contentsToInsert.push(element);
            } else if (element.category === 'field') {
              fieldsToInsert.push(element);
            }
            continue;
          }

          if (element.category === 'content') {
            promises.push(this.handleUpdateSingleContentCategory(element));
          } else if (element.category === 'field') {
            promises.push(this.handleUpdateSingleFieldCategory(element));
          }
        }

        promises.push(this.handleInsertMultipleFieldsCategory(fieldsToInsert));
        promises.push(
          this.handleInsertMultipleContentsCategory(contentsToInsert)
        );

        const results = await Promise.allSettled(promises);
        this.$loading(false);

        const errors = results.filter((result) => result.status === 'rejected');

        if (errors.length > 0) {
          this.errorOnSave = true;
          errors.forEach((error) => {
            let res = error.reason.response;
            const documentId = res?.config?.url?.split('/')?.slice(-2)?.[0];
            if (documentId) {
              this.errorDocuments.add(documentId);
            }
            const message =
              res.data.message ?? this.$t('modal.envelope.fields.elementError');
            alert.fireAlert(message, {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
              tag: 'httpAlert',
              icon: 'triangle-exclamation',
            });
          });
          if (
            this.errorDocuments.size > 0 &&
            !this.errorDocuments.has(this.selectedDocument?.id)
          ) {
            // reload render pdf
            window.location.reload(); // TODO - needs refactor
          }
        }
      } finally {
        this.pendingSave = false;
      }
    },
    async handleUpdateSingleFieldCategory(field) {
      const data = EnvelopeManager.generateApiFieldObject(field);
      return EnvelopesService.updateDocumentField(
        this.$route.params.id,
        field.document,
        field.id,
        data
      ).then((res) => {
        field.id = res.data.id;
        field.inApi = true;
        field.updated = false;
      });
    },
    async handleInsertMultipleFieldsCategory(fields) {
      if (!fields.length) {
        return Promise.resolve();
      }
      //index for fields is document-id
      this.documentsFields = this.groupBy(fields, 'document');
      //all promises for docs
      return Promise.all(
        Object.entries(this.documentsFields).map(
          async ([documentId, documentFields]) => {
            const data = documentFields.map((field) =>
              EnvelopeManager.generateApiFieldObject(field, true)
            );
            try {
              const res = await EnvelopesService.addDocumentMultipleFields(
                this.$route.params.id,
                documentId,
                data
              );
              documentFields.forEach((field, index) => {
                field.id = res.data[index].id;
                field.inApi = true;
                field.updated = false;
              });
            } catch (e) {
              documentFields.forEach((field) => {
                field.inApi = false;
              });
              console.error(
                `Error on save multiple fields in this document ${documentId}!`
              );
              throw e;
            }
          }
        )
      );
    },
    async handleUpdateSingleContentCategory(element) {
      const data = EnvelopeManager.generateApiContentObject(element);

      return EnvelopesService.updateDocumentContent(
        this.$route.params.id,
        element.document,
        element.id,
        data
      ).then((res) => {
        element.id = res.data.id;
        element.inApi = true;
        element.updated = false;
      });
    },
    async handleInsertMultipleContentsCategory(contents) {
      if (!contents.length) {
        return Promise.resolve();
      }
      //index for contents is document-id
      this.documentsContents = this.groupBy(contents, 'document');
      //all promises for docs
      return Promise.all(
        Object.entries(this.documentsContents).map(
          async ([documentId, documentContents]) => {
            const data = documentContents.map((content) =>
              EnvelopeManager.generateApiContentObject(content)
            );

            try {
              const res = await EnvelopesService.addDocumentMultipleContents(
                this.$route.params.id,
                documentId,
                data
              );
              documentContents.forEach((content, index) => {
                content.id = res.data[index].id;
                content.inApi = true;
                content.updated = false;
              });
            } catch (e) {
              documentContents.forEach((content) => {
                content.inApi = false;
              });
              console.error(
                `Error on save multiple contents in this document ${documentId}!`
              );
              throw e;
            }
          }
        )
      );
    },
    async handleExcludeRecipientsFromDocuments() {
      const envelopeId = this.$route.params.id;

      const recipientsWithDocsExclusions = this.signers.filter(
        (signer) =>
          this.excludeRecipientsPayload.some(
            (item) => item.recipientUuid === signer.id
          ) ||
          this.fromApiExcludeRecipientsPayload.some(
            (item) => item.recipientUuid === signer.id
          )
      );
      await Promise.all(
        recipientsWithDocsExclusions.map((signer) => {
          const documentsUuids = this.excludeRecipientsPayload
            .filter((item) => item.recipientUuid === signer.id)
            .map((item) => item.documentUuid);
          return EnvelopesService.excludeRecipientDocuments(
            envelopeId,
            signer.id,
            documentsUuids
          );
        })
      );
    },
    openEnvelopeSubmittedToReviewModal() {
      this.$refs.envelopeSubmittedToReviewModal.$refs.modal.open();
    },
    async next() {
      this.errorOnSave = false;
      try {
        await this.handleExcludeRecipientsFromDocuments();
      } catch (error) {
        this.errorOnSave = true;
        const message = this.$t('modal.envelope.fields.elementError');
        alert.fireAlert(message, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      await this.saveFields(); // save fields and contents
      // show warning if any document has any overlapping fields or content but is accepted
      if (this.verifyOverlapInAllDocs(this.$root.warningOverlapPercent)) {
        setTimeout(() => {
          const message = this.$t('modal.envelope.fields.overlapEnvelope');
          alert.fireAlert(message, {
            classes: 'alert-warning',
            styles:
              'background-color: #FFFCE2; border-color: #EBE5A7; color: #635B00;',
            tag: 'httpAlert',
            icon: 'circle-exclamation',
          });
        }, 50);
      }
      if (this.errorOnSave) {
        console.error('Error on save fields and contents!');
        return;
      }
      await this.$router.replace({
        name: 'business.envelope.review',
        params: {
          id: this.$route.params.id,
          isNew: this.$route.params.isNew,
          isTemplate: this.isTemplate,
          isNewTemplate: this.isNewTemplate,
        },
      });
    },
    async changeEnvelopeReviewer(event) {
      if (event === true) {
        try {
          this.$loading(true);
          await EnvelopesService.releaseEnvelopeReview(this.$route.params.id);
        } catch (error) {
          Logger.consoleError('Error to release envelope review', error);
        } finally {
          this.$loading(false);
        }
      }
      await this.$router.push({ name: 'business.documents.waiting-review' });
    },
    async saveAndClose() {
      // save exclusions in draft
      await this.handleExcludeRecipientsFromDocuments();
      await this.saveFields();
      if (this.isWaitingReview) {
        this.$refs.changeEnvelopeReviewerModal.$refs.modal.open();
        return;
      }
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.push({ name: 'business.documents.draft' });
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    calculateOverlap(el1, el2) {
      const safe = (primary, fallback = 0) =>
        Number.isFinite(primary)
          ? primary
          : Number.isFinite(fallback)
          ? fallback
          : 0;

      // rectangles for calculate overlap
      const left1 = safe(el1.apiX, el1.x);
      const top1 = safe(el1.apiY, el1.y);
      const left2 = safe(el2.apiX, el2.x);
      const top2 = safe(el2.apiY, el2.y);
      const right1 = left1 + safe(el1.apiWidth, el1.width);
      const bottom1 = top1 + safe(el1.apiHeight, el1.height);
      const right2 = left2 + safe(el2.apiWidth, el2.width);
      const bottom2 = top2 + safe(el2.apiHeight, el2.height);

      if (
        right1 < left2 ||
        left1 > right2 ||
        bottom1 < top2 ||
        top1 > bottom2
      ) {
        return 0;
      }

      const overlapLeft = Math.max(left1, left2);
      const overlapRight = Math.min(right1, right2);
      const overlapTop = Math.max(top1, top2);
      const overlapBottom = Math.min(bottom1, bottom2);

      const overlapArea =
        (overlapRight - overlapLeft) * (overlapBottom - overlapTop);
      const smallerArea = Math.min(
        el1.apiWidth * el1.apiHeight,
        el2.apiWidth * el2.apiHeight
      );
      return overlapArea / smallerArea;
    },
  },
  filters: {
    recipientType: (type) => RecipientType.getText(type),
  },
};
</script>
<style lang="stylus">
.blocked
  pointer-events: none
  opacity: 0.4
  filter: grayscale(1)
  cursor: not-allowed

.fields-screen
  .title-font-size
    font-size: 14px
  .side-bar
    max-width: 450px
    .card
      margin-bottom: 1rem
  .drag-item
    display: flex
    align-items: center
    justify-content: space-between
    font-size: .9em
    font-weight: 600
    cursor: move
    background-color: #E6F0F4
    color: #013D52
    padding: 6px 0px 6px 0px
    margin-bottom: .5rem
    border-radius: 50px
    .icon
      font-size: 15px
    .icon-background
      margin-left: 6px
      padding: 4px
      background-color: #FFFFFF
      border-radius: 50px
    .field-name
      font-size: 1.2em
      font-weight: 500;
  .recipient-select
    .vs__selected-options
      margin-left: 0
    .vs__dropdown-toggle
      padding-left: 2.4em
    .v-select
      position: relative
      &::before
        content: ""
        position: absolute
        background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fal' data-name='user' class='svg-inline--fa fa-user fa-w-14' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath fill='%23013D52' d='M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z'%3E%3C/path%3E%3C/svg%3E")
        background-repeat: no-repeat
        width: 14px
        height: 14px
        background-size: 12px
        top: 48%
        left: 14px
        margin-top: -7px
        color: #013D52
        font-size: 1rem
        padding: 9px 10px
        font-weight: bold
        display: block
</style>
